module.exports = function (value) {
  return Boolean(value) ? "checked" : "";
};
